/**
 * Referrals step rendered conditionally during the `complete-intake`
 * activity flow when the user picks `triage` or `cocm + include-referrals`.
 * Wraps the existing `ReferralsSection`.
 *
 * @agentic connections
 */

import type { UseFormReturnType } from "@mantine/form";
import { ReferralsSection } from "../sections/ReferralsSection";
import type {
  ClinicalIntakeInteractionFormData,
  CoCMIntakeInteractionFormData,
} from "@benchmark/core/types";

/** Intake form data shapes that include the chain fields. @agentic connections */
type ReferralsCapableFormData =
  ClinicalIntakeInteractionFormData | CoCMIntakeInteractionFormData;

/**
 * Props for {@link ReferralsStep}.
 *
 * @agentic connections
 */
export type ReferralsStepProps<T extends ReferralsCapableFormData> = {
  form: UseFormReturnType<T>;
};

/**
 * Referrals step. Forwards the typed `useForm` to the now-generic
 * `ReferralsSection` without an `as unknown as` cast.
 *
 * @agentic connections
 */
export const ReferralsStep = <T extends ReferralsCapableFormData>({
  form,
}: ReferralsStepProps<T>) => <ReferralsSection form={form} />;
